import { sortAlphabetically } from './_utils'
import { UserButtonSelectorProps } from '../_props'

type WithIdAndName = {
    id?: string
    name?: string
}

export const computeOptions = <T extends WithIdAndName>(data: T[]): UserButtonSelectorProps[] => {
    const options = data.map((item) => ({
        label: item.name ?? '',
        value: item.name ?? '',
        id: item.id ?? '',
    }))

    sortAlphabetically(options)

    return options
}
